import { defineComponent as _defineComponent } from 'vue'
import { useAlertsStore } from "@/stores/alertsStore";
import { storeToRefs } from "pinia";
import IconCheck from "@/icons/icon-check.vue";
import IconClose from "@/icons/icon-close.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppAlerts',
  setup(__props, { expose: __expose }) {
  __expose();

const { setAlertById } = useAlertsStore();
const { alerts } = storeToRefs(useAlertsStore());

const __returned__ = { setAlertById, alerts, get useAlertsStore() { return useAlertsStore }, get storeToRefs() { return storeToRefs }, IconCheck, IconClose }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})